import { API } from 'services/common'

/**
 * Execute a callback with admin token from localStorage
 * Automatically sets the x-btm-site header to 'dailybreak.com'
 * Restores the original token and site after execution
 *
 * @example
 * await adminRequest(async () => {
 *   const response = await doGet2('/admin/pages', {})
 *   const editResponse = await doPutWithFormData('/admin/page-builder/123', data)
 * })
 */
export async function adminRequest<T>(
  callback: () => Promise<T>
): Promise<T> {
  const originalToken = API.getToken()
  const originalSite = API.getSite()
  const adminToken = localStorage.getItem('adminToken')

  if (!adminToken) {
    throw new Error('Admin token not found in localStorage')
  }

  API.setToken(adminToken)
  API.setSite('dailybreak.com')

  try {
    return await callback()
  } finally {
    API.setToken(originalToken)
    API.setSite(originalSite)
  }
}
